<template>
  <div class="contentBox min-w-1400">
    <div class="flexBox min-w-1400">
      <div class="imgBox max-w-1400">
        <img :src="importedImg1" class="imgItem" />
      </div>
    </div>
    <div class="flexBox min-w-1400">
      <div class="flexGroup max-w-1400">
        <img :src="importedImg2a" class="imgItem" />
        <img :src="importedImg2b" class="imgItem" />
        <img :src="importedImg2c" class="imgItem" />
        <img :src="importedImg2d" class="imgItem" />
      </div>
    </div>
    <div class="flexBox min-w-1400 fade-in-section">
      <div class="imgBox max-w-1400">
        <img :src="importedImg3" alt="" class="imgItem" />
      </div>
    </div>
  </div>
</template>

<script>
import "./index.css";
import importedImg1 from "@/page/cre.inversionesmartinsas/components/img/service1.png";
import importedImg2a from "@/page/cre.inversionesmartinsas/components/img/service2a.png";
import importedImg2b from "@/page/cre.inversionesmartinsas/components/img/service2b.png";
import importedImg2c from "@/page/cre.inversionesmartinsas/components/img/service2c.png";
import importedImg2d from "@/page/cre.inversionesmartinsas/components/img/service2d.png";
import importedImg3 from "@/page/cre.inversionesmartinsas/components/img/service3.png";

export default {
  data() {
    return {
      importedImg1,
      importedImg2a,
      importedImg2b,
      importedImg2c,
      importedImg2d,
      importedImg3,
    };
  },
  mounted() {
    this.InitPage();
  },
  methods: {
    InitPage(){
      window.scrollTo({ top: 0 });
      const fadeInSections = document.querySelectorAll('.fade-in-section');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
      });
    }, {
        threshold: 0.1
    });
      fadeInSections.forEach(section => {
          observer.observe(section);
      });
    }
  },
};
</script>

<style scoped>
.contentBox {
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
}

img {
  display: block;
}
.flexBox{
  display: flex;
  justify-content: center;
  width: 100%;
}

.flexGroup {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 80px 200px;
  background-color: #F8F8F8;
}

.flexGroup .imgItem {
  margin: 20px;
  width: 45%;
  opacity: 0; /* 初始状态设置为透明 */
  animation: fadeIn 0.5s ease-in-out forwards;
}

/* 为每个imgItem设置不同的动画延迟 */
.flexGroup .imgItem:nth-child(1) {
  animation-delay: 0s;
}
.flexGroup .imgItem:nth-child(2) {
  animation-delay: 0.4s;
}
.flexGroup .imgItem:nth-child(3) {
  animation-delay: 0.8s;
}
.flexGroup .imgItem:nth-child(4) {
  animation-delay: 1.2s;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translate(-100px,60px);
  }
  to {
    opacity: 1;
    transform: translate(0,0);
  }
}

.imgBox{
  margin: 0;
  overflow: hidden;
  width: 100%;
  background-color: "";
}

.imgItem {
  width: 100%;
  margin: 0;
}

.themeColor {
  background-color: #E9F4F5;
}


</style>
